// src/app/sentry-error.handler.ts
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    Sentry.captureException(error.originalError || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/SentryErrorHandler.ts